<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!--협의체 정보-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>{{ $t('위원회 정보') }}</h5>
      <div class="writeGridContainer">
        <!--        <div >-->
        <!--          <div class="label-text">{{ $t('구분') }}</div>-->
        <!--          <p v-if="isPrint" >{{ form.inputA_1 }}</p>-->
        <!--          <vs-select-->
        <!--            v-model="form.inputA_1"-->
        <!--            autocomplete-->
        <!--            v-else-->
        <!--            :readonly="board.readonly"-->
        <!--            -->
        <!--          >-->
        <!--            <vs-select-item text="최초" value="최초" />-->
        <!--            <vs-select-item text="정기" value="정기" />-->
        <!--            <vs-select-item text="수시" value="수시" />-->
        <!--          </vs-select>-->
        <!--        </div>-->
        <div>
          <div>{{ $t('회의일') }}</div>
          <span v-if="isPrint" class="print-input"> {{form.inputA_2}} </span>
          <date-selector v-else v-model="form.inputA_2" :readonly="board.readonly" />
        </div>
        <!--        <div >-->
        <!--          <div >{{ $t('차수') }}</div>-->
        <!--          <p v-if="isPrint" >{{ form.inputA_3 }}</p>-->
        <!--          <ml-input-->
        <!--            :readonly="board.readonly"-->
        <!--            v-else-->
        <!--            v-model="form.inputA_3"-->
        <!--            -->
        <!--          />-->
        <!--        </div>-->
        <div>
          <div>{{ $t('노측 위원(명)') }}</div>
          <span v-if="isPrint" class="print-input"> {{form.inputA_4}} </span>
          <comma-input :readonly="board.readonly" v-else type="number" v-model="form.inputA_4" />
        </div>
        <div>
          <div>{{ $t('사측 위원(명)') }}</div>
          <span v-if="isPrint" class="print-input"> {{form.inputA_5}} </span>
          <comma-input :readonly="board.readonly" v-else type="number" v-model="form.inputA_5" />
        </div>
      </div>
    </div>

    <!-- 위험성평가협의회(사용자) -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="산업안전보건위원회(사용자)"
      :tableData="[
        { id: 'cell1', title: '소속명', type: 'text', placeholder: '' },
        { id: 'cell2', title: '직책', type: 'text', placeholder: '' },
        { id: 'cell3', title: '이름', type: 'text', placeholder: '' },
        { id: 'cell4', title: '서명', type: 'sign', placeholder: '' },
        { id: 'cell5', title: '비고', type: 'text', placeholder: '' },
      ]"
      :mobile="['cell1', 'cell3']"
      v-model="form.userTableList"
      class="mt-28px"
    />

    <!-- 위험성평가협의회(근로자) -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="산업안전보건위원회(근로자)"
      :tableData="[
        { id: 'cell1', title: '소속명', type: 'text', placeholder: '' },
        { id: 'cell2', title: '직책', type: 'text', placeholder: '' },
        { id: 'cell3', title: '이름', type: 'text', placeholder: '' },
        { id: 'cell4', title: '서명', type: 'sign', placeholder: '' },
        { id: 'cell5', title: '비고', type: 'text', placeholder: '' },
      ]"
      :mobile="['cell1', 'cell3']"
      v-model="form.workerTableList"
      class="mt-28px"
    />

    <!-- 안심의 의결사항 및 결정사항 -->
    <TableInspectMerge
      :is-print="isPrint"
      :is-readonly="board.readonly"
      title="점검표"
      :tableHeaderCheck="[{ text: '작성', width: '110' }, { text: '미작성', width: '110' }, { text: 'N/A', width: '110' }]"
      :tableHeaderNote="[{ text: '심의결정사항', width: '288' }]"
      v-model="form.inspectList"
      class="mt-28px"
      :only-pc="!isMobile"
    >
      <template #trFooter>
        <ul style="list-style: none; padding-left: 0; text-align: left;">
          <li style="list-style: none; padding-left: 0;">{{ $t('※ 미이행 시 과태료') }}</li>
          <li style="list-style: none; padding-left: 0;"><span class="px-1">•</span>{{ $t('사업주 : (1차) 50만원, (2차) 250만원, (3차) 500만원') }}</li>
          <li style="list-style: none; padding-left: 0;"><span class="px-1">•</span>{{ $t('근로자 : (1차) 10만원, (2차) 20만원, (3차) 30만원') }}</li>
        </ul>
      </template>
    </TableInspectMerge>

    <div class="writeGridContainer mt-28px">
      <div class="writeGridLineItem">
        <div>{{ $t('심의사항') }}</div>
        <span v-if="isPrint" class="print-textarea"> {{form.inputB_1}} </span>
        <ml-textarea v-else rows="5" v-model="form.inputB_1" :readonly="board.readonly" />
      </div>
      <div class="writeGridLineItem">
        <div>{{ $t('의결사항') }}</div>
        <span v-if="isPrint" class="print-textarea"> {{form.inputB_2}} </span>
        <ml-textarea v-else rows="5" v-model="form.inputB_2" :readonly="board.readonly" />
      </div>
      <div class="writeGridLineItem">
        <div>{{ $t('기타사항') }}</div>
        <span v-if="isPrint" class="print-textarea"> {{form.inputB_3}} </span>
        <ml-textarea v-else rows="5" v-model="form.inputB_3" :readonly="board.readonly" />
      </div>
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" section-title="사진대지" placeholder="점검 현장 사진" :is-print="isPrint" :readonly="board.readonly" class="mt-28px" />

    <!--    파일첨부-->
    <file-upload-module v-model="form.fileList" :readonly="board.readonly" class="mt-28px"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import DateSelector from "@/components/selector/DateSelector";
import TableCustom from "@/components/TableCustom";
import TableInspectMerge from "@/components/TableInspectMerge";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import SignField from "@/components/SignField";

export default {
  components: {
    SignField,
    FieldSelectModule,
    DateSelector,
    TableCustom,
    TableInspectMerge,
    PhotoUploadGridModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.summary = {
          산업안전보건위원회_사업장명: [],
          산업안전보건위원회_구분: [],
        };

        value.summary["산업안전보건위원회_사업장명"].push({
          [this.form.stdInfo.field_name]: 1,
        });

        value.summary["산업안전보건위원회_구분"].push({
          [this.form.inputA_1]: 1,
        });

        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      isMobile: false,
      form: {
        stdInfo: {},
        userTableList: [],
        workerTableList: [],
        inspectList: [
          {
            content: "산업재해 예방계획의 수립",
            isChecked: "",
          },
          {
            content: "안전보건관리규정의 작성·변경",
            isChecked: "",
          },
          {
            content: "근로자의 안전·보건교육",
            isChecked: "",
          },
          {
            content: "작업환경의 점검 및 개선",
            isChecked: "",
          },
          {
            content: "종사자의 건강진단 등 건강관리",
            isChecked: "",
          },
          {
            content: "산업재해의 원인 조사 및 재발 방지대책 수립",
            isChecked: "",
          },
          {
            content: "산업재해에 관한 통계의 기록 및 유지",
            isChecked: "",
          },
          {
            content: "유해하거나 위험한 기계·기구와 그 밖의 설비를 도입한 경우 안전·보건조치",
            isChecked: "",
          },
          {
            content: "근로자 안전보건 유지·증진을 위해 필요한 사항",
            isChecked: "",
          },
        ],
        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        photoList: [],
        fileList: [],
      },
    };
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },
  },
  async created() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
};
</script>
